import { render } from "./project.vue?vue&type=template&id=e4cfc50a&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"

import "./project.vue?vue&type=style&index=0&id=e4cfc50a&scoped=true&lang=scss"

import exportComponent from "/home/duke/code/duke-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4cfc50a"]])

export default __exports__